export default __webpack_public_path__ + "static/media/lithium.eba5f820.png";